<template>
  <div>
    <transition name="fade">
      <b-card no-body class="dashboard-card">
        <div class="card-smallHeader card-header-action" v-b-toggle.collapseQualification>
          <!-- <b-link class="card-header-action btn-minimize" v-b-toggle.collapseRecherche> -->
          <i class="fa fa-list-alt mr-2"></i>
          <strong>Dashboard Qualification</strong>
          <div class="card-header-actions">
            <!-- <b-link class="card-header-action btn-minimize" v-b-toggle.collapseRecherche> -->
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            <!-- </b-link> -->
          </div>
          <!-- </b-link> -->
        </div>
        <b-collapse id="collapseQualification" :visible="!$parent.canAccessDashboardGestion()">
          <b-card-body class="xsmall-padding">
            <table id="dashboardQualification" class="dashboard">
              <thead>
                <tr>
                  <th class="headerDashboard">{{ textHeader }}</th>
                  <th class="headerDashboard" v-for="status in statusTraite" :key="status.id">{{ status.libelle_bo }}</th>
                  <th class="headerDashboard">TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="bal in allBals" :key="'bal-'+bal.id">
                  <td class="basketDashboard text-left" key="qualif-col-0">{{ bal.nom }}</td>
                  <td v-for="(status, index) in statusTraite" :key="'qualif-col-'+status.id">
                    <a v-if="statistiquesQualification[bal.id][status.id] !== undefined" href="#" @click.prevent="getDossiersQualification(status.id,bal)">{{  statistiquesQualification[bal.id][status.id] }}</a>
                    <span v-else> - </span>
                  </td>
                  <td class="basketDashboard"><a href="#" @click.prevent="getDossiersQualification('all',bal)">{{ totauxQualification[bal.id] }}</a></td>
                </tr>
              </tbody>
            </table>
            <b-form-checkbox v-if="isManager()" variant="info" @change="changeDashboard()" class="align-top d-inline-block ml-2" switch>{{ textBoutonSwitch }}</b-form-checkbox>
          </b-card-body>
        </b-collapse>
      </b-card>
    </transition>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken, getUser } from '@/utils/auth'
import {en, fr} from 'vuejs-datepicker/dist/locale'

export default {
  props: [],
  data() {
    return {
      allBals: [],
      statusTraite: [],
      statistiquesQualification: [],
      totauxQualification: [],
      textBoutonSwitch: 'Passer au suivi des gestionnaires',
      actualDashboard: 'bals',
      textHeader: 'BAL'
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider() 
  },
  mounted() {
    this.getBals()
    this.getQualificationDashboard()
  },
  methods: {
    getDossiersQualification(statusId, bal) {
      if (this.actualDashboard === 'bals') {
        this.$parent.clearForm()
        this.$parent.balId = bal.id
        this.$parent.fromDashboard = 'fromDashboard'
        this.$parent.statusIds = statusId === 'all' ? this.statusTraite.map(status => status.id) : statusId
        this.$parent.statusId = statusId === 'all' ? null : statusId
        // this.$parent.getDossiers(statusId, balId)
        this.$parent.$refs.dashboard_dossier_table.$refs.table.refresh()
      } else if (this.actualDashboard === 'gestionnaires') {
        // console.log(bal)
        this.$parent.clearForm()
        this.$parent.balId = ''
        this.$parent.gestionnaireNom = bal.nom
        this.$parent.gestionnairePrenom = bal.prenom
        this.$parent.gestionnaire = bal.id
        this.$parent.gestionnaires.push({id: bal.id, nom: bal.nom, prenom: bal.prenom})
        this.$parent.statusIds = statusId === 'all' ? this.statusTraite.map(status => status.id) : statusId
        this.$parent.statusId = statusId === 'all' ? null : statusId
        this.$parent.$refs.dashboard_dossier_table.$refs.table.refresh()
      }
    },
    getQualificationDashboard() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/espaceGestion/dossier/dashboardQualification")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          // console.log(response)
          this.statusTraite = response.data.status
          this.$parent.statusTraite = response.data.status
          this.statistiquesQualification = response.data.stats

          for(let indexRow in this.statistiquesQualification) {
            let total = 0
            // console.log(this.statistiquesQualification[indexRow])
            for(let indexCol in this.statistiquesQualification[indexRow]) {
              total += this.statistiquesQualification[indexRow][indexCol]
            }
            this.totauxQualification[indexRow] = total
          }
        })
        .catch(function(error) {
          console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    getBals() {
      let self = this
      let dataPost = {
        'provider': getProvider()
      }
      this.$store.commit("IS_LOADING", true)
      this.$axios
        .post("/espaceGestion/mail/getBals", dataPost)
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.allBals = response.data.bals
          // console.log(this.allBals)
        })
        .catch(function(error) {
          console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    getSuiviDashboard() {
      let self = this
      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/espaceGestion/dossier/dashboardSuivi/qualification")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          // console.log(response)
          this.statusTraite = response.data.status
          // this.$parent.statusTraite = response.data.status
          this.statistiquesQualification = response.data.stats
          this.allBals = response.data.gestionnaires

          for(let indexRow in this.statistiquesQualification) {
            let total = 0
            // console.log(this.statistiquesQualification[indexRow])
            for(let indexCol in this.statistiquesQualification[indexRow]) {
              total += this.statistiquesQualification[indexRow][indexCol]
            }
            this.totauxQualification[indexRow] = total
          }
        })
        .catch(function(error) {
          console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    changeDashboard() {

      if (this.actualDashboard === 'bals') {
        this.actualDashboard = 'gestionnaires'
        this.textBoutonSwitch = 'Revenir au suivi des dossiers'
        this.textHeader = 'Gestionnaires'

        this.getSuiviDashboard()

      } else if (this.actualDashboard === 'gestionnaires') {
        this.actualDashboard = 'bals'
        this.textBoutonSwitch = 'Passer au suivi des gestionnaires'
        this.textHeader = 'BAL'

        this.getBals()
        this.getQualificationDashboard()
      }
    },
    isManager() {
      let user = getUser()
      let isManager = false
      user.equipes.map( equipe => {
        if (equipe.pivot.role === 'responsable') {
          isManager = true
        }
      })
      // Cas des admin dgp et superadmin
      if (user.profil_active[0].code === 'ZZ' || user.profil_active[0].code === '0A') {
        isManager = true
      }
      return isManager
    },
  }
}
</script>

<style>

</style>
